var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "object-block-contact", class: _vm.objectBlockClasses },
    [
      _vm.variant === _vm.OBJECT_BLOCK_VARIANT.PREVIEW &&
      _vm.state === _vm.ENUMS_STATE.EMPTY
        ? [
            _c("CompassObject", {
              attrs: { object: "contact", size: _vm.objectSize }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "typographies-paragraph-medium-regular object-block__header-caption"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t.__("overview.contactBlock.empty.description")
                    ) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                size: "small",
                type: "secondary",
                label: _vm.$t.__("overview.contactBlock.empty.button")
              },
              on: {
                click: function($event) {
                  return _vm.$emit("handleCreateContact")
                }
              }
            })
          ]
        : _vm.variant === _vm.OBJECT_BLOCK_VARIANT.SELECTION
        ? [
            _vm.state === _vm.ENUMS_STATE.DEFAULT
              ? [
                  _c(
                    "div",
                    { staticClass: "object-block__header-title-container" },
                    [
                      _c("BlockName", {
                        attrs: { name: _vm.fullName, link: _vm.linkCard }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "typographies-paragraph-medium-regular object-block__header-caption"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$filters.capitalize(_vm.objectCaption)
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("CompassButton", {
                    attrs: {
                      leftIcon: "plus",
                      type: "tertiary",
                      label: _vm.$t.__("common.actions.contact_link_to", {
                        object: "idk"
                      })
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("handleLinkToObject")
                      }
                    }
                  })
                ]
              : _vm.state === _vm.ENUMS_STATE.SELECTED
              ? [
                  _c(
                    "div",
                    { staticClass: "object-block__header-title-container" },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "object-block-contact__header-name typographies-paragraph-medium-semibold"
                        },
                        [
                          _c("CompassObject", {
                            attrs: { object: "avatar", size: _vm.objectSize }
                          }),
                          _vm._v(" "),
                          _c("BlockName", {
                            attrs: { name: _vm.fullName, link: _vm.linkCard }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "typographies-paragraph-medium-regular object-block__header-caption"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$filters.capitalize(_vm.objectCaption)
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "object-block__header-actions" },
                    [
                      _c("CompassButton", {
                        attrs: {
                          type: "tertiary",
                          label: _vm.$t.__("common.actions.edit")
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("edit")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("CompassButton", {
                        attrs: {
                          type: "tertiary",
                          label: _vm.$t.__("common.actions.unlink_object")
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("unlink")
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              : [
                  _c("CompassObject", {
                    attrs: { object: "avatar", size: _vm.objectSize }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "typographies-paragraph-medium-regular object-block__header-caption"
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.__(
                              "common.object.BlockContact.labels.no_contact_linked"
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  )
                ]
          ]
        : [
            _c(
              "div",
              { staticClass: "object-block__header" },
              [
                _c(
                  "div",
                  { staticClass: "object-block__header-title-container" },
                  [
                    _c("CompassObject", {
                      attrs: { object: "contact", size: _vm.objectSize }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("BlockName", {
                          attrs: {
                            name: _vm.fullName,
                            link: !_vm.displayLink ? _vm.linkCard : null
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "typographies-paragraph-small-regular object-block__header-caption"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$filters.capitalize(_vm.objectCaption)
                                ) +
                                "\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.displayLink
                  ? _c("CompassLink", {
                      attrs: {
                        label: _vm.linkLabel,
                        link: _vm.linkCard,
                        target: "_blank"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.variant === _vm.OBJECT_BLOCK_VARIANT.LINKED
                  ? _c("CompassIconButton", {
                      attrs: { icon: "close" },
                      on: {
                        click: function($event) {
                          return _vm.$emit("unlink")
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.displayDescriptionList && _vm.hasDescriptionListItem
              ? _c(
                  "BlockDescriptionListPart",
                  _vm._b(
                    {
                      attrs: { showCompany: _vm.displayCompanyDescriptionItem }
                    },
                    "BlockDescriptionListPart",
                    _vm.$props,
                    false
                  )
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.variant === _vm.OBJECT_BLOCK_VARIANT.OVERVIEW
              ? _vm._t("company")
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }